import QueryString from 'query-string';
import { useLocation } from 'react-router-dom';

enum View {
  WEB_VIEW = 'WEB_VIEW',
}

export const useIsWebView = () => {
  const { search } = useLocation();
  const queryString = QueryString.parse(search);
  if (queryString?.view === View.WEB_VIEW) {
    return true;
  }
  return false;
};
